import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
    listRoot: {
        display: "flex",
        justifyContent: "flex-start",
    },
    root: {
        "& .MuiCardHeader-root": {
            backgroundColor: "#e5e5e5",
        },
        maxWidth: 275,
        marginBottom: theme.spacing(2),
        marginRight: "auto",
        
    },
    avatar: {
        position: "relative",
        bottom: 70,
        display: "flex",
        justifyContent: "center",
    },
    largeAvatar: {
        width: theme.spacing(20),
        height: theme.spacing(20),
    },
    contentRoot: {
        paddingBottom: "0 !important",
    },
    content: {
        position: "relative",
        bottom: 54,
    },
    center: {
        
        
        
        textAlign: "center",
    },
    optionButton: {
        color: theme.palette.primary.opacityText7,
    },
    iconUser: {
        width: 25,
        position: "absolute",
        top: 10,
        left: 10,
    },
}));
export default useStyles;
